import React from 'react';
import PropTypes from 'prop-types';
import IconWithText from 'components/Widgets/IconWithText';

import moment from 'moment';

export default function StartAt({ session }) {
  if (!session.attributes.start_at) {
    return null;
  }

  return (
    <IconWithText
      iconClassName="calendar-icon bg-gray-800"
      iconBg="bg-gray-100"
      wrapperClassName="mb-4"
    >
      <>
        <div className="small text-gray-800">
          Start on
        </div>

        <div className="fw-semibold text-gray-900">
          {moment(session.attributes.start_at)
            .utcOffset(session.attributes.start_at_offset / 60)
            .format('MMMM D, YYYY [at] hh:mm A')}
          {' '}
          {session.attributes.time_zone_formatted}
        </div>
      </>
    </IconWithText>
  );
}

StartAt.propTypes = {
  session: PropTypes.object.isRequired,
};
